// extracted by mini-css-extract-plugin
export default {"container":"TeamItem_container__NrXdA","icon":"TeamItem_icon__GIfFR","link":"TeamItem_link__mlBEw"};